import http from '@/services/http'
import { delayed } from '@/utils'

function getInitialState() {
  return {
    fetchInProgress: false,
    alreadyFetched: false,
    program: {
      id: null,
      name: null,
      apply_text: '',
      description: '',
      questions: [],
      onboarding_mail_subject: '',
      onboarding_mail_text: '',
      has_end_date: true,
      send_reminders: true,
    },
    original: {},
    saveInProgress: false,
    errors: {},
  }
}

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    CLEAN(state) {
      Object.assign(state, getInitialState())
    },
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    SET_PROGRAM(state, program) {
      state.program = program
      state.original = program
      state.alreadyFetched = true
    },

    CLEAN_API_ERRORS(state) {
      state.errors = {}
      Object.assign(state.errors, getEmptyErrors())
    },
    SET_API_ERRORS(state, errors) {
      state.errors = errors
    },

    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },
  },
  actions: {
    async fetch({ commit, state }, { organizationId, programId }) {
      return await fetchProgram(
        { commit, state },
        { organizationId, programId },
      )
    },
    async getProgram({ commit, state }, { organizationId, programId }) {
      if (state.alreadyFetched) {
        return state.program
      } else {
        return await fetchProgram(
          { commit, state },
          { organizationId, programId, once: true },
        )
      }
    },
    async save({ commit, state }, { organizationId, data }) {
      commit('CLEAN_API_ERRORS')
      commit('START_SAVE')
      const url = `/organizations/${organizationId}/update-program`
      try {
        await http.postAuthed(url, data)
        commit('SET_PROGRAM', Object.assign({}, state.program, data))
      } catch (error) {
        commit('SET_API_ERRORS', error.response.data)
        throw error
      } finally {
        commit('STOP_SAVE')
      }
    },
  },
}

const requests = {}

async function fetchProgram(
  { commit, state },
  { organizationId, programId, once = false, delay = 0 },
) {
  commit('CLEAN')
  commit('START_FETCH')
  const url = `/organizations/${organizationId}/programs/${programId}`
  let request
  if (once && requests[url]) {
    request = requests[url]
  } else {
    request = http.getAuthed(url)
    requests[url] = request
  }

  try {
    const response = await delayed(request, delay)
    commit('SET_PROGRAM', response.data)
    return state.program
  } finally {
    commit('STOP_FETCH')
    requests[url] = null
  }
}

function getEmptyErrors() {
  return {
    name: [],
    questions: [],
  }
}
